interface BusinessPurposeDisclaimerProps {
    isReview?: boolean;
}

export const BusinessPurposeDisclaimer: React.FC<BusinessPurposeDisclaimerProps> = ({ isReview = false }) => {
    return (
        <>
            {isReview && (
                <div
                    style={{
                        padding: '15px 0px 15px 0px',
                    }}
                >
                    <strong>
                        I acknowledge that this application is for a BUSINESS PURPOSE AND that the property is or will be OWNED BY
                        A CORPORATE ENTITY.
                    </strong>
                </div>
            )}
        </>
    );
};
